const HisOutlinedCross = ({ color, sx }) => {
  const strokeColor = color ?? "#708FBB";

  return (
    <svg
      style={sx}
      stroke={strokeColor}
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.3052 2.67578C14.5978 2.67578 13.9195 2.95677 13.4193 3.45693C12.9192 3.95708 12.6382 4.63544 12.6382 5.34277V12.0103H5.9707C5.26337 12.0103 4.58501 12.2912 4.08485 12.7914C3.5847 13.2916 3.30371 13.9699 3.30371 14.6772V17.3442C3.30371 18.8111 4.50386 20.0112 5.9707 20.0112H12.6382V26.6787C12.6382 28.1456 13.8383 29.3457 15.3052 29.3457H17.9722C18.6795 29.3457 19.3579 29.0647 19.858 28.5646C20.3582 28.0644 20.6392 27.386 20.6392 26.6787V20.0112H27.3066C28.014 20.0112 28.6923 19.7302 29.1925 19.2301C29.6926 18.7299 29.9736 18.0516 29.9736 17.3442V14.6772C29.9736 13.9699 29.6926 13.2916 29.1925 12.7914C28.6923 12.2912 28.014 12.0103 27.3066 12.0103H20.6392V5.34277C20.6392 4.63544 20.3582 3.95708 19.858 3.45693C19.3579 2.95677 18.6795 2.67578 17.9722 2.67578H15.3052Z"
        stroke="#0B4EDB"
        strokeWidth="2.66699"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default HisOutlinedCross;
